"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssElements = void 0;
var cssElements = {
  '*, *:before, *:after': {
    boxSizing: 'border-box',
    padding: 0,
    margin: 0
  },
  body: {
    'line-height': '1.5',
    '-webkit-touch-callout': 'none',
    pointerEvents: 'inherit !important',
    fontSmoothing: 'antialiased',
    '-webkit-font-smoothing': 'antialiased',
    '*': {
      '-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)'
    }
  },
  ':focus-visible': {
    borderRadius: 1
  },
  ':focus:not(:focus-visible)': {
    outline: 'none'
  },
  'h1, h2, h3, h4, h5, h6, label, p, button, abbr, a, small': {
    fontSmoothing: 'antialiased',
    '-webkit-font-smoothing': 'antialiased',
    textSizeAdjust: '100%'
  },
  p: {
    marginBottom: '10px'
  },
  a: {
    color: '$interactive1',
    textDecoration: 'none',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
    '&:hover, &:active': {
      textDecoration: 'underline',
      color: '$interactive2'
    }
  },
  'button, input, optgroup, select, textarea': {
    fontFamily: '$primary',
    border: 'none',
    outline: 'none',
    appearance: 'none',
    '-webkit-touch-callout': 'none',
    '-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)'
  },
  button: {
    cursor: 'pointer',
    'background-color': 'transparent'
  },
  '[disabled]': {
    cursor: 'not-allowed'
  },
  img: {
    maxWidth: '100%',
    height: 'auto'
  },
  'code, kbp, samp': {
    fontFamily: 'Menlo, Monaco, "Lucida Console", monospace',
    color: '$gray8',
    border: "1px solid $gray4",
    backgroundColor: '$gray1',
    padding: '1px 5px',
    fontSize: 13,
    lineHeight: 1.4,
    borderRadius: 4,
    '-webkit-font-smoothing': 'antialiased'
  }
};
exports.cssElements = cssElements;